import {ApiClientError, apiRequest} from './client';
import type {
    AdminSite,
    AdminStats,
    PaginatedResponse,
    User,
    UserDetail
} from '@/types/api';

export async function getStats(): Promise<AdminStats> {
    return apiRequest<AdminStats>('/admin/stats', {
        method: 'GET'
    });
}

async function paginatedRequest<T>(endpoint: string): Promise<PaginatedResponse<T>> {
    const response = await fetch(`/api${endpoint}`, {
        headers: {
            'Content-Type': 'application/json'
        }
    });

    if (response.status === 401) {
        window.location.href = '/login';
        throw new ApiClientError('Unauthorized', 'UNAUTHORIZED');
    }

    const json = await response.json();

    if (!response.ok || !json.success) {
        throw new ApiClientError(
            json.error?.message || 'An unexpected error occurred',
            json.error?.code || 'UNKNOWN_ERROR'
        );
    }

    return {
        data: json.data,
        pagination: json.pagination
    };
}

export async function getUsers(
    page: number = 1,
    search: string = '',
    role: string = ''
): Promise<PaginatedResponse<User>> {
    const params = new URLSearchParams({
        page: page.toString(),
        ...(search && {search}),
        ...(role && {role})
    });

    return paginatedRequest<User>(`/admin/users?${params}`);
}

export async function getUserDetail(id: string): Promise<UserDetail> {
    return apiRequest<UserDetail>(`/admin/users/${id}`, {
        method: 'GET'
    });
}

export async function getSites(
    page: number = 1,
    search: string = '',
    status: string = ''
): Promise<PaginatedResponse<AdminSite>> {
    const params = new URLSearchParams({
        page: page.toString(),
        ...(search && {search}),
        ...(status && {status})
    });

    return paginatedRequest<AdminSite>(`/admin/sites?${params}`);
}

export async function suspendSite(id: string): Promise<AdminSite> {
    return apiRequest<AdminSite>(`/admin/sites/${id}/suspend`, {
        method: 'POST'
    });
}

export async function reactivateSite(id: string): Promise<AdminSite> {
    return apiRequest<AdminSite>(`/admin/sites/${id}/reactivate`, {
        method: 'POST'
    });
}

